<template>
    <el-popover
        popper-class="columns-setting-dialog-wrapper"
        placement="top"
        width="213"
        trigger="click"
        v-model="visible"
    >
        <div class="icon-table-settings" slot="reference">
        </div>
        <div class="columns-setting-dialog">
            <p class="title">
                Выводить столбцы
            </p>
            <el-form @keyup.enter.native="columnsSelected">
                <div class="body">
                    <el-checkbox-group class="dialog-checkbox-group" v-model="columns">
                        <el-checkbox
                            class="dialog-checkbox"
                            size="medium"
                            name="columns"
                            v-for="column in settingColumns"
                            :label="column.colId"
                            :key="column.colId"
                        >
                            {{ column.colDef.headerName }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="warning" @click="columnsSelected" class="apply-button">
                    Применить
                </el-button>
            </span>
        </div>
    </el-popover>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'TableHeaderSettings',
    data() {
        return {
            visible: false,
            showDialog: false,
            columns: [],
            allColumns: []
        };
    },
    computed: {
        settingColumns() {
            const showLtv = this.params.context && this.params.context.showLtvColumns;
            return this.allColumns.filter(column => {
                if (column.getColDef().ltvOnly && !showLtv) {
                    return false;
                }
                return true;
            });
        }
    },
    watch: {
        visible(isOpen) {
            if (isOpen) {
                this.refreshColumnSelection();
            }
        }
    },
    mounted() {
        this.allColumns = this.params.columnApi.getAllColumns().filter(column => column.getColId() !== '0');
        this.refreshColumnSelection();
    },
    methods: {
        refreshColumnSelection() {
            this.columns = this.params.columnApi.getAllDisplayedColumns()
                .map(column => column.getColId())
                .filter(id => this.settingColumns.some(column => column.getColId() === id));
        },
        columnsSelected() {
            const difference = this.settingColumns.map(column => column.getColId()).filter(id => !this.columns.includes(id));
            this.params.columnApi.setColumnsVisible(difference, false);
            this.params.columnApi.setColumnsVisible(this.columns, true);
            const tagColumn = this.params.columnApi.getColumn('tags');
            if (tagColumn) {
                this.params.api.resetRowHeights();
            }
            this.visible = false;
        }
    }
});
</script>
